export default __webpack_public_path__ + "static/media/biofit-builder-series-IP.c59f28c4.png";